import {setFieldVisibility} from "../../../../apps/KpModule/actions";

export const entity = {
    name: 'DemandCategory',
    facets: [
        {name: 'codeName', uniqueName: true}
    ],
    fields: [
        'Category',
        {path: 'display', type: 'boolean'}
    ],
    filters: [
        {
            name: "engagementProcessType",
            isDefault: false,
            query: function () {
                return {category: "2"}
            }
        },
    ]
}

export const module_ = {
    object: 'DemandCategory',
    category: {
        path: 'process',
        icon: 'repeat'
    },
    tKey: 'processType',
    defaultSortBy: 'name',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            'code',
            {
                path: 'name',
                type: 'translatedText'
            },
            {path: 'category', tKey: 'process'}
        ],
        form: {
            fields: [
                {path: 'code', editable: false},
                {path: 'name', type: 'textarea', placeholder: 'fr:: nom en français\nen:: name in english\n...'},
                {
                    path: 'category',
                    tKey: 'process',
                    default: {id:'1'},
                    editable: false,
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, module}) => {
                            const displayField = module.viewMap.form.fields.find(field => field.path === 'display')
                            const isEngagementProcess = newValue?.id === '2'
                            store.dispatch(setFieldVisibility(displayField.id, isEngagementProcess))
                            if (!isEngagementProcess) displayField.setValue(false)
                        }
                    }
                },
                {path: 'display', tKey: 'displayEngagementData'}
            ],
            onOpen: ({ store, module, t }) => {
                const categoryField = module.viewMap.form.fields.find(field => field.path === 'category')
                const displayField = module.viewMap.form.fields.find(field => field.path === 'display')
                const category = categoryField && categoryField.getValue()
                store.dispatch(setFieldVisibility(displayField.id, category?.id === '2'))
            }
        }
    }
}
